export default {
  modals: {
    delete_payment_method: {
      title: 'Êtes-vous sûr de vouloir supprimer ce moyen de paiement ?',
    },
  },
  buttons: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
  },
  toasts: {
    failed_to_delete_payment_method: 'Échec de la suppression du moyen de paiement',
    payment_method_deleted: 'Moyen de paiement supprimé',
  },
};
